export type MetricsCategory =
  | 'Digital Wellbeing'
  | 'Online Safety'
  | 'Data Ownership'

export const MetricsCategories: MetricsCategory[] = [
  'Digital Wellbeing',
  'Online Safety',
  'Data Ownership',
]

export type ChecklistSummary = {
  numUpdatedOrFulfilled: number
  numSkipped: number
  numIncomplete: number
}
